import { Dispatch } from 'redux';
import { actions } from '../../modules/Actions';
import { VisitReservationBasicInfo } from '../../reducers/HearingInfoReducer';
import { dateToFormatString } from '../../../Common';
import { getHearingInfoApi } from '../../../external/HearingInfoApi';

export const clearHearingInfoAll = (dispatch: Dispatch) => {
  dispatch(actions.hearingInfo.resetHearingInfo());
};

export const updateVisitReservationInfo = (visitReservationInfo: VisitReservationBasicInfo, dispatch: Dispatch) => {
  dispatch(actions.hearingInfo.updateDataOpenModal(visitReservationInfo));
};

export const fetchHearingInfoAll = async (hearingId: string | null, targetDate: Date, targetStore: string, dispatch: Dispatch) => {
  dispatch(actions.hearingInfo.loadingModal(true));
  const searchDate = dateToFormatString(targetDate, 'yyyy/MM/dd');
  const { hearingQuestionAnswerDtos } = await getHearingInfoApi({
    hearingId,
    scheduleStartDate: searchDate,
    scheduleEndDate: searchDate,
    agencyCd: targetStore,
  });
  dispatch(actions.hearingInfo.updateHearingInfoList(hearingQuestionAnswerDtos || []));
  dispatch(actions.hearingInfo.loadingModal(false));
};
